import apiClient from './apiClient'

export interface Department {
  id: number
  name: string
  code: string | null
}

export interface Position {
  id: number
  name: string
  code: string | null
  departmentId: number
}

export const referenceDataService = {
  getDepartments: () =>
    apiClient.get<Department[]>('/departments').then(r => r.data),

  getPositions: () =>
    apiClient.get<Position[]>('/positions').then(r => r.data),
}
